import { render, staticRenderFns } from "./StatisticComponentWrapper.vue?vue&type=template&id=9e640354&scoped=true"
import script from "./StatisticComponentWrapper.vue?vue&type=script&lang=ts"
export * from "./StatisticComponentWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e640354",
  null
  
)

export default component.exports